module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "consent",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [(_vm.intent) ? _c('v-card-text', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.intent.ShortDescription))]), _vm._v(" "), _c('div', {
    staticClass: "subheading pt-3"
  }, [_vm._v(_vm._s(_vm.intent.Description))]), _vm._v(" "), (_vm.intent) ? _c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.intent.Scopes), function(Scope) {
    return _c('v-list-tile', {
      key: Scope
    }, [_c('v-list-tile-content', [_c('v-list-tile-sub-title', {
      staticClass: "title subheading"
    }, [_vm._v(_vm._s(Scope))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    staticClass: "pt-2",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Expiration date",
      "prepend-icon": "event",
      "readonly": "",
      "value": _vm.consent.Expiration
    },
    on: {
      "input": _vm.updateExpiration
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "value": _vm.consent.Expiration
    },
    on: {
      "input": _vm.updateExpiration
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3 pr-3",
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "justify title caption"
  }, [_vm._v("\n                            " + _vm._s(_vm.issuer.Name) + " and NowYu will use this information in accordance with their respective terms of service and privacy policies.\n                        ")])])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("\n                    Back\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.revoke()
      }
    }
  }, [_vm._v("\n                    Revoke\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v("\n                    Update\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f0d4d96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Consent.vue
// module id = 392
// module chunks = 0